import LazyLoad from "vanilla-lazyload";

let lazyLoadInst = null;

export default () => {
  if (!lazyLoadInst) {
    lazyLoadInst = new LazyLoad({
      'elements_selector': '.lazy',
      'threshold': 0,
      callback_loaded: function(element) {
        const parent = element.parentElement;

        // Check if the parent has the class 'hero__bg__image'
        if (parent.classList.contains('hero__bg__image')) {
          // Check if 'hero__bg__image' has a sibling or a parent with the class 'hero__bg__image--medium'
          if (parent.classList.contains('hero__bg__image--medium') || 
              parent.parentElement.classList.contains('hero__bg__image--medium')) {
            element.style.opacity = 1; // Set opacity to 1 if parent has 'hero__bg__image--medium'
          } else {
            element.style.opacity = 0.2; // Set opacity to 0.2 if parent is only 'hero__bg__image'
          }
        } else {
          element.style.opacity = 1; // Set opacity to 1 for all other parents
        }
      },
    });
  }
  
  lazyLoadInst.update();
  
  window.addEventListener('ajaxupdated', () => {
    lazyLoadInst.update();
  });
}
